// extracted by mini-css-extract-plugin
export default {"close":"index_close_gfrBa","num":"index_num_9LTH4","current":"index_current_07015","total":"index_total_LQuyh"};